import React from 'react';
import { array, arrayOf, object, shape, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { REVIEW_RATINGS } from '../../util/types';
import { PropertyGroup } from '../../components';
import IconReviewStar from '../../components/IconReviewStar/IconReviewStar';
import { OTHER_OPTION } from '../../marketplace-custom-config';

import css from './ListingPage.module.css';

const SectionCategorizedFeaturesMaybe = props => {
  const { categories, sectionId, selectedOptions, otherValueMaybe, ratingsByKey } = props;
  const selectedSet = new Set(selectedOptions || []);

  const renderStarsMaybe = ratingMaybe => {
    const rating = parseInt(ratingMaybe, 10);
    if (Number.isNaN(rating) || !REVIEW_RATINGS.includes(rating)) {
      return null;
    }

    return (
      <span className={css.skillRatingStars}>
        {REVIEW_RATINGS.map(star => (
          <IconReviewStar
            key={star}
            className={css.skillRatingStar}
            rootClassName={star <= rating ? css.skillRatingStarFilled : css.skillRatingStarEmpty}
            isFilled={star <= rating}
          />
        ))}
      </span>
    );
  };

  const selectedByCategory = categories
    .map(category => {
      const selectedSkills = (category.skills || [])
        .filter(skill => selectedSet.has(skill.key))
        .map(skill => {
          const label =
            skill.key === OTHER_OPTION && otherValueMaybe ? otherValueMaybe : skill.label || skill.key;
          const stars = renderStarsMaybe(ratingsByKey ? ratingsByKey[skill.key] : null);

          const displayLabel = stars ? (
            <span className={css.skillLabelWithRating}>
              <span>{label}</span>
              {stars}
            </span>
          ) : (
            label
          );

          return { ...skill, label: displayLabel };
        });

      return {
        key: category.key,
        label: category.label,
        selectedSkills,
      };
    })
    .filter(category => category.selectedSkills.length > 0);

  return selectedByCategory.length > 0 ? (
    <div className={css.sectionDescription}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id={`${sectionId}Title`} />
      </h2>

      {selectedByCategory.map(category => (
        <div key={`${sectionId}.${category.key}`}>
          <p className={css.sectionSubHeading}>{category.label}</p>
          <PropertyGroup
            id={`${sectionId}.${category.key}`}
            rootClassName={css.categorizedPropertyGroup}
            options={category.selectedSkills}
            selectedOptions={category.selectedSkills.map(skill => skill.key)}
          />
        </div>
      ))}
    </div>
  ) : null;
};

SectionCategorizedFeaturesMaybe.defaultProps = {
  selectedOptions: [],
  otherValueMaybe: '',
  ratingsByKey: null,
};

SectionCategorizedFeaturesMaybe.propTypes = {
  categories: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
      skills: arrayOf(
        shape({
          key: string.isRequired,
          label: string.isRequired,
        })
      ),
    })
  ).isRequired,
  sectionId: string.isRequired,
  selectedOptions: array,
  otherValueMaybe: string,
  ratingsByKey: object,
};

export default SectionCategorizedFeaturesMaybe;